import React, { Children } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function ReservationDetail() {
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 Nov 2025',
      checkOut: '11 Nov 2025',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: '$1.00',
      serviceCharge: '$0.10'
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-5057">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-5058">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-5059">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-5060" />
          <span data-id="element-5061">Reservation Details</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5062">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-5063">
          <div className="flex justify-between items-center" data-id="element-5064">
            <h2 className="text-xl font-bold" data-id="element-5065">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-5066">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-5067">
                Confirmed
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-5068">
                Resend confirmation email
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-5069">
          <div className="p-6 border-r border-gray-200" data-id="element-5070">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5071">Date</h3>
            <p className="text-gray-900 font-medium" data-id="element-5072">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-5073">
              {reservation.date.nights} Nights
            </p>
          </div>
          <div className="p-6" data-id="element-5074">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5075">
              Guests & Rooms
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-5076">
              {reservation.guests.adults} Adults, {reservation.guests.children}{' '}
              Children, {reservation.guests.infants} Infants
            </p>
            <p className="text-sm text-gray-500" data-id="element-5077">
              {reservation.guests.rooms} Room
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5078">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5079">Booking Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5080">
            <div data-id="element-5081">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5082">Booking ID</p>
              <p className="text-sm text-gray-900" data-id="element-5083">{reservation.booking.id}</p>
            </div>
            <div data-id="element-5084">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5085">Transaction ID</p>
              <p className="text-sm text-gray-900" data-id="element-5086">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5087">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5088">Hotel</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5089">
            <div data-id="element-5090">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5091">Name</p>
              <p className="text-sm text-gray-900" data-id="element-5092">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-5093">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5094">Hotel ID</p>
              <p className="text-sm text-gray-900" data-id="element-5095">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5096">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5097">Room Type</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5098">
            <div data-id="element-5099">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5100">Name</p>
              <p className="text-sm text-gray-900" data-id="element-5101">{reservation.room.name}</p>
            </div>
            <div data-id="element-5102">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5103">View</p>
              <p className="text-sm text-gray-900" data-id="element-5104">{reservation.room.view}</p>
            </div>
            <div data-id="element-5105">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5106">Category</p>
              <p className="text-sm text-gray-900" data-id="element-5107">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5108">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5109">Guest Information</h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-5110">
            <h4 className="text-base font-medium mb-4" data-id="element-5111">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5112">
              <div data-id="element-5113">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5114">Email</p>
                <p className="text-sm text-gray-900" data-id="element-5115">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-5116">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5117">Phone number</p>
                <p className="text-sm text-gray-900" data-id="element-5118">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-5119">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5120">Passport number</p>
                <p className="text-sm text-gray-900" data-id="element-5121">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-5122">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5123">Date of birth</p>
                <p className="text-sm text-gray-900" data-id="element-5124">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-5125">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5126">Nationality</p>
                <p className="text-sm text-gray-900" data-id="element-5127">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-5128">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5129">Special Requests</p>
                <p className="text-sm text-gray-900" data-id="element-5130">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-5131">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5132">Rate Details</h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-5133">
            <div data-id="element-5134">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5135">Rate Name</p>
              <p className="text-sm text-gray-900" data-id="element-5136">{reservation.rate.name}</p>
            </div>
            <div data-id="element-5137">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5138">Description</p>
              <p className="text-sm text-gray-900" data-id="element-5139">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-5140">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5141">Price Breakdown</h3>
          <div className="space-y-3" data-id="element-5142">
            <div className="flex justify-between" data-id="element-5143">
              <p className="text-sm text-gray-500" data-id="element-5144">Subtotal</p>
              <p className="text-sm text-gray-900" data-id="element-5145">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-5146">
              <p className="text-sm text-gray-500" data-id="element-5147">Service charge</p>
              <p className="text-sm text-gray-900" data-id="element-5148">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-5149">
              <p className="text-sm font-medium" data-id="element-5150">Total</p>
              <p className="text-sm font-bold" data-id="element-5151">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}